import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Box, CircularProgress} from 'views/components';

import HourlyRateContent from './payment_plan/hourly_rate/Content';
import StripeIdContent from './payment_plan/stripe_id/Content';
import AutopayContent from './payment_plan/autopay/Content';

const PaymentPlan = (props) => {
  const clientRn = props.clientRn;
  const refresh = props.refresh;
  const clientBackend = props.clientBackend;
  const clientPaymentPlan = props.clientPaymentPlan;
  const clientPaymentPlanLoading = props.clientPaymentPlanLoading;

  React.useEffect(() => {
    if (!clientPaymentPlan) {
      clientBackend.payment.loadClientHourlyRate();
    }
  }, [clientRn, refresh, clientPaymentPlan]);

  const updateClientHourlyRate = (newValue, onSuccess) => {
    clientBackend.payment.updateClientHourlyRate(newValue, onSuccess);
  };
  const updateClientStripeId = (newValue, onSuccess) => {
    clientBackend.payment.updateClientStripeId(newValue, onSuccess);
  };
  const updateClientAutoCharge = (newValue, onSuccess) => {
    clientBackend.payment.updateClientAutoCharge(newValue, onSuccess);
  };

  if (clientPaymentPlanLoading) {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Stack
      spacing={2}
      direction={'row'}
      justifyContent="space-between"
      sx={{
        width: '100%',
      }}
    >
      <Box
        sx={{
          width: '33%',
        }}
      >
        <HourlyRateContent
          clientPaymentPlan={clientPaymentPlan || {}}
          updateClientHourlyRate={updateClientHourlyRate}
        />
      </Box>
      <Box
        sx={{
          width: '33%',
        }}
      >
        <StripeIdContent
          clientPaymentPlan={clientPaymentPlan || {}}
          updateClientStripeId={updateClientStripeId}
        />
      </Box>
      <Box
        sx={{
          width: '33%',
        }}
      >
        <AutopayContent
          clientPaymentPlan={clientPaymentPlan || {}}
          updateClientAutoCharge={updateClientAutoCharge}
        />
      </Box>
    </Stack>
  );
};

PaymentPlan.propTypes = {
  refresh: PropTypes.number.isRequired,
  clientRn: PropTypes.string.isRequired,
  clientBackend: PropTypes.object.isRequired,
  clientPaymentPlan: PropTypes.object,
  clientPaymentPlanLoading: PropTypes.bool.isRequired,
};

export default React.memo(PaymentPlan);
